import styled from 'styled-components/macro'

export const Number = styled.div<{ color: string }>`
  color: ${({ color }) => color};
`
